<template>
  <div id="business">
    <div class="content_box">
      <div class="img_container business_img"></div>

      <div class="contents_title fade_in"> 
        <p class="contents_font"> Business </p>
      </div>

      <div id="business_info" class="content_info">
        <p class="main_font margin_item"> Our Business </p>
        <div class="business_container">
          <div class="business_item margin_item"> 
            <div v-b-modal.modal-1 class="content_card"> 
              <div class="content_card_img" id="business_img1"></div>
              <div class="card_info">
                <p class="sub_font pline"> 차량 데이터 수집&#38;분석 Solution </p>
                <p class="subinfo_font"> OBD2 System </p>
                <p class="info_font pline"> OBD2 System 기반의 차량 데이터 수집용 송수신 단말기 개발 </p>
                <p class="info_font pline"> 차량 운행관리 모델 및 데이터 수집 Solution 제공</p>
              </div>
            </div>
          </div>
          <div class="business_item margin_item"> 
            <div v-b-modal.modal-2 class="content_card"> 
              <div class="content_card_img" id="business_img2"></div>
              <div class="card_info">
                <p class="sub_font"> 위치관제 System </p>
                <p class="info_font pline"> 실시간 차량위치 파악 및 운행기록 관리 시스템 개발 </p>
                <p class="info_font pline"> 차량 위치관제 및 운행관리 서비스 제공 </p>

              </div>
            </div>
          </div>
          <div class="business_item margin_item">
            <div v-b-modal.modal-5 class="content_card"> 
              <div class="content_card_img" id="business_img5"></div>
              <div class="card_info">
                <p class="sub_font"> 전기차 탄소배출계수 측정 Solution </p>
                <p class="info_font pline"> 온실가스 배출권거래사업을 위한 </p>
                <p class="info_font pline"> 전기차 탄소배출계수 측정 Solution 제공</p>
              </div>
            </div>
          </div>
          <div class="business_item margin_item"> 
            <div v-b-modal.modal-3 class="content_card"> 
              <div class="content_card_img" id="business_img3"></div>
              <div class="card_info">
                <p class="sub_font"> 사고인지 System </p>
                <p class="info_font pline"> 실시간 차량 데이터 기반의 사고인지 시스템 개발 </p>
                <p class="info_font pline"> 차량 사고인지 및 소모품 관리 서비스 제공 </p>
              </div>
            </div>
          </div>
          <div class="business_item margin_item">
            <div v-b-modal.modal-4 class="content_card"> 
              <div class="content_card_img" id="business_img4"></div>
              <div class="card_info">
                <p class="sub_font"> 예측진단 System </p>
                <p class="info_font pline"> 누적 차량 데이터 기반의 예측진단 System 기술 모델 확보 </p>
              </div>
            </div>
          </div>
          <div class="empty_item"> </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-1" 
    title="전기차 데이터 수집&분석 Solution" 
    hide-footer="true"
    size="xl">
      <BusinessModal1/>
    </b-modal>

    <b-modal id="modal-2" 
    title="위치관제 System" 
    hide-footer="true"
    size="xl">
      <BusinessModal2/>
    </b-modal>

    <b-modal id="modal-3" 
    title="사고인지 System" 
    hide-footer="true"
    size="xl">
      <BusinessModal3/>
    </b-modal>

    <b-modal id="modal-4" 
    title="예측진단 System" 
    hide-footer="true"
    size="xl">
      <BusinessModal4/>
    </b-modal>

    <b-modal id="modal-5" 
    title="전기차 탄소배출계수 측정 Solution" 
    hide-footer="true"
    size="xl">
      <BusinessModal5/>
    </b-modal>
  </div>
</template>

<script>
import BusinessModal1 from '../components/BusinessModal1';
import BusinessModal2 from '../components/BusinessModal2';
import BusinessModal3 from '../components/BusinessModal3';
import BusinessModal4 from '../components/BusinessModal4';
import BusinessModal5 from '../components/BusinessModal5';


export default {
  components : {
    BusinessModal1,
    BusinessModal2,
    BusinessModal3,
    BusinessModal4,
    BusinessModal5
  }

}

</script>

<style>

#business {
  text-align: center;
}

.business_img {
  background-image: url(../../public/img/business.jpg);
  filter: brightness(50%); 
}

#business_info {
  margin-top: 40px;
}

.business_container {
  padding-top: 40px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  flex-wrap: wrap;
  align-content: stretch;
}

.business_item {
  width: 450px;
  height: 450px;
}

.empty_item {
  width: 450px;
  height: 450px;
}

#business_img1 {
  background-image: url(../../public/img/business_img1.jpg);
}

#business_img2 {
  background-image: url(../../public/img/business_img2.jpg);
}

#business_img3 {
  background-image: url(../../public/img/business_img3.jpg);
}

#business_img4 {
  background-image: url(../../public/img/business_img4.jpg);
}

#business_img5 {
  background-image: url(../../public/img/business_img5.jpg);
}


/* 미디어쿼리 */
@media screen and (min-width: 1600px) {
  .business_item {
    width: 450px;
    height: 450px;
  }
}

@media screen and (max-width: 1400px) {
  .business_item {
    width: 350px;
    height: 400px;
  }

  .empty_item {
    width: 350px;
    height: 350px;
  }
}

@media screen and (max-width: 1200px) {
  .business_item {
    width: 350px;
    height: 400px;
  }

  .empty_item {
    width: 350px;
    height: 350px;
  }
}

@media screen and (max-width: 1067px) {
  .business_item {
    width: 350px;
    height: 420px;
  }

  .empty_item {
    width: 350px;
    height: 350px;
  }
}

@media screen and (max-width: 767px) {
  
  .business_item {
    width: 350px;
    height: 450px;
  }

  .empty_item {
    display: none;
  }
}

@media screen and (max-width: 479px) {
  .business_item {
    width: 350px;
    height: 400px;
  }

  .main_font {
    font-size: 20px;
  }
  .sub_font {
    font-size: 17px;
  }
  .info_font {
    font-size: 15px;
  }
  .subinfo_font {
    font-size: 12px;
  }
  .business_item {
    width: 350px;
    height: 470px;
  }

  .empty_item {
    display: none;
  }
}
</style>
